import { gql } from "@apollo/client";

export const CATEGORY_COMPANY_COUNT_QUERY = gql`
  query categoryCompanyCountQuery(
    $categoryIds: [Identifier]!
    $localizeInstalls: Boolean!
    $isDp: Boolean
    $isDu: Boolean
    $isGhq: Boolean
    $isGp: Boolean
    $isGu: Boolean
  ) {
    opportunityGeneratorSearch(
      filters: {
        productCategories: { ids: $categoryIds }
        isDp: $isDp
        isDu: $isDu
        isGhq: $isGhq
        isGp: $isGp
        isGu: $isGu
      }
      localizeInstalls: $localizeInstalls
    ) {
      data {
        name
        hgId
        url
        countryName
        revenueRange {
          min
          max
          band
        }
      }
      count
    }
  }
`;
